module.exports = __webpack_public_path__ + "img/sliders_2-03.cf7c52cb.png";